import { Cookies } from "react-cookie";

export function setToken(name, value) {
  const cookies = new Cookies();
  cookies.set(name, value, { domain: ".morman.vn", path: "/" });
  cookies.set(name, value, { domain: "localhost", path: "/" });
  // IP → KHÔNG set domain
  cookies.set(name, value, { path: "/" });
  return null;
}
export function getToken(name) {
  const cookies = new Cookies();
  return cookies.get(name);
}
export function removeToken(name) {
  const cookies = new Cookies();
  cookies.remove(name, { domain: ".morman.vn", path: "/" });
  cookies.remove(name);
  // IP
  cookies.remove(name, { path: "/" });
}
